import React, { useState } from 'react';
import {
  Typography,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Collapse
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';
import SeoBodySub1, {
  SeoHeader as SeoHeaderSub1,
  seoMeta as seoMetaSub1
} from './seo/SeoSub1Charshafi';
import SeoBodySub2, {
  SeoHeader as SeoHeaderSub2,
  seoMeta as seoMetaSub2
} from './seo/SeoSub2Kalufki';
import SeoBodySub4, {
  SeoHeader as SeoHeaderSub4,
  seoMeta as seoMetaSub4
} from './seo/SeoSub4Plikove';
import SeoBodySub6, {
  SeoHeader as SeoHeaderSub6,
  seoMeta as seoMetaSub6
} from './seo/SeoSub6KrugliCharshafi';
import SeoBodyCat2Sub7, {
  SeoHeader as SeoHeaderCat2Sub7,
  seoMeta as seoMetaCat2Sub7
} from './seo/SeoCat2Sub7DetskiCharshafi';
import SeoBodyCat2Sub8, {
  SeoHeader as SeoHeaderCat2Sub8,
  seoMeta as seoMetaCat2Sub8
} from './seo/SeoCat2Sub8DetskiKalufki';
import SeoBodyCat2Sub9, {
  SeoHeader as SeoHeaderCat2Sub9,
  seoMeta as seoMetaCat2Sub9
} from './seo/SeoCat2Sub9DetskiCharshafiSLastik';
import SeoBodyCat2Sub10, {
  SeoHeader as SeoHeaderCat2Sub10,
  seoMeta as seoMetaCat2Sub10
} from './seo/SeoCat2Sub10DetskiPlikove';

// FAQ data for structured data (FAQPage schema)
const faqDataSub3 = [
  {
    q: 'Как да избера правилния размер чаршаф с ластик?',
    a: 'За да изберете правилния размер чаршаф с ластик, трябва да знаете ширината, дължината и височината на матрака. При поръчка тези параметри се вземат предвид, за да може чаршафът да прилегне добре и да обхване стабилно матрака.'
  },
  {
    q: 'Как да измеря правилно матрака?',
    a: 'Измерете три основни параметъра: ширина – разстоянието от едната до другата страна на матрака, дължина – разстоянието от горната до долната част, височина – дебелината на матрака. Тези размери са необходими, за да може чаршафът да бъде изработен така, че да пасва добре.'
  },
  {
    q: 'Как да избера правилната височина на чаршафа с ластик?',
    a: 'При поръчка е важно да посочите височината на матрака. Например при матрак с височина около 25 см: ако искате чаршафът да следва приблизително височината на матрака – изберете 21–25 см; ако искате чаршафът да обхваща матрака по-добре и да се подпъхва под матрака – изберете 26–30 см или 31–40 см.'
  },
  {
    q: 'Подходящи ли са чаршафите с ластик за високи матраци?',
    a: 'Да. Чаршафите могат да бъдат изработени за матраци с различна височина и са подходящи както за стандартни, така и за по-високи матраци, включително матраци с топ матрак, ортопедични матраци и легла тип боксспринг (boxspring).'
  },
  {
    q: 'Свиват ли се памучните чаршафи при пране?',
    a: 'Памучните платове могат да имат естествена свиваемост около 4–5% след пране. При изработката се предвижда необходимият запас, така че чаршафът да пасва добре и след пране.'
  },
  {
    q: 'От какъв плат са изработени чаршафите с ластик?',
    a: 'Чаршафите се изработват от 100% памук, като можете да избирате между две основни материи: ранфорс – здрав и дишащ памучен плат, подходящ за ежедневно използване; памучен сатен – по-гладка и фина памучна материя с лек естествен блясък.'
  },
  {
    q: 'Могат ли чаршафите да се изработят по индивидуален размер?',
    a: 'Да. Чаршафите с ластик се изработват по индивидуални параметри според размера на матрака, което позволява да поръчате чаршаф, който пасва точно на вашето легло.'
  },
  {
    q: 'За колко време се изработват чаршафите?',
    a: 'Чаршафите се изработват по поръчка. Обичайният срок за изработка е между 3 и 10 работни дни, като в повечето случаи поръчките са готови в рамките на 4–7 работни дни.'
  }
];

export function getFaqData(categoryId, subCategoryId) {
  if (categoryId === '1' && subCategoryId === '3') return faqDataSub3;
  return null;
}

export function getSeoMeta(categoryId, subCategoryId) {
  if (categoryId === '1') {
    if (subCategoryId === '1') return seoMetaSub1;
    if (subCategoryId === '2') return seoMetaSub2;
    if (subCategoryId === '3') {
      return {
        title: 'Чаршафи с ластик от 100% памук | Размери по поръчка | GoToBed',
        description:
          'Чаршафи с ластик от 100% памук в размери 80/200 до 200/200 и нестандартни. Ранфорс и памучен сатен, изработка по размер на матрак. Поръчайте онлайн от GoToBed.'
      };
    }
    if (subCategoryId === '4') return seoMetaSub4;
    if (subCategoryId === '6') return seoMetaSub6;
  }
  if (categoryId === '2') {
    if (subCategoryId === '7') return seoMetaCat2Sub7;
    if (subCategoryId === '8') return seoMetaCat2Sub8;
    if (subCategoryId === '9') return seoMetaCat2Sub9;
    if (subCategoryId === '10') return seoMetaCat2Sub10;
  }
  return null;
}

export function LastUpdatedLabel({ date }) {
  return (
    <Typography variant="caption" sx={{ color: 'text.disabled', display: 'block', mb: 2 }}>
      Последна актуализация: {date}
    </Typography>
  );
}

const seoLinkStyle = {
  color: '#F57819',
  textDecoration: 'underline',
  fontWeight: 600,
  '&:hover': { color: '#A34D08' }
};

export function CategorySeoHeader({ categoryId, subCategoryId }) {
  if (categoryId === '1') {
    if (subCategoryId === '1') return <SeoHeaderSub1 />;
    if (subCategoryId === '2') return <SeoHeaderSub2 />;
    if (subCategoryId === '3') return <SeoHeaderSub3 />;
    if (subCategoryId === '4') return <SeoHeaderSub4 />;
    if (subCategoryId === '6') return <SeoHeaderSub6 />;
  }
  if (categoryId === '2') {
    if (subCategoryId === '7') return <SeoHeaderCat2Sub7 />;
    if (subCategoryId === '8') return <SeoHeaderCat2Sub8 />;
    if (subCategoryId === '9') return <SeoHeaderCat2Sub9 />;
    if (subCategoryId === '10') return <SeoHeaderCat2Sub10 />;
  }
  return null;
}

function SeoHeaderSub3() {
  const [introExpanded, setIntroExpanded] = useState(false);

  return (
    <Box sx={{ mb: 3 }}>
      <Typography
        component="h1"
        sx={{
          position: 'absolute',
          width: '1px',
          height: '1px',
          padding: 0,
          margin: '-1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
          whiteSpace: 'nowrap',
          borderWidth: 0
        }}>
        Чаршафи с ластик
      </Typography>
      <Typography variant="h6" component="p" fontWeight={600} sx={{ mb: 2 }}>
        Чаршафи с ластик от 100% памук в голямо разнообразие от размери
      </Typography>
      <Box
        sx={{
          ...(!introExpanded && {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden'
          })
        }}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В тази категория ще откриете чаршафи с ластик от 100% памук, подходящи за различни размери
          матраци. Предлагаме богато разнообразие от размери – едно от основните предимства на нашия
          магазин. Налични са популярни размери като 80/200, 90/200, 100/200, 120/200, 140/200,
          160/200, 180/200 и 200/200, както и варианти за матраци с дължина 190–220 см и височина
          10–50 см.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Чаршафите се изработват от висококачествени памучни материи – ранфорс и памучен сатен,
          които са дишащи, приятни на допир и подходящи за ежедневно използване. Благодарение на
          ластика по целия ръб чаршафът прилепва стабилно към матрака и остава на мястото си по
          време на сън.
        </Typography>
      </Box>
      <Button
        onClick={() => setIntroExpanded(!introExpanded)}
        size="small"
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          p: 0,
          minWidth: 0,
          '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
        }}>
        {introExpanded ? 'Скрий' : 'Прочетете повече'}
      </Button>
    </Box>
  );
}

export default function CategorySeoBody({ categoryId, subCategoryId }) {
  if (categoryId === '1') {
    if (subCategoryId === '1') return <SeoBodySub1 />;
    if (subCategoryId === '2') return <SeoBodySub2 />;
    if (subCategoryId === '3') return <SeoBodyFittedSheets />;
    if (subCategoryId === '4') return <SeoBodySub4 />;
    if (subCategoryId === '6') return <SeoBodySub6 />;
  }
  if (categoryId === '2') {
    if (subCategoryId === '7') return <SeoBodyCat2Sub7 />;
    if (subCategoryId === '8') return <SeoBodyCat2Sub8 />;
    if (subCategoryId === '9') return <SeoBodyCat2Sub9 />;
    if (subCategoryId === '10') return <SeoBodyCat2Sub10 />;
  }
  return null;
}

function SeoBodyFittedSheets() {
  const [expanded, setExpanded] = useState(false);

  return (
    <Box sx={{ mt: 6 }}>
      <LastUpdatedLabel date="28.03.2026" />
      {/* H2: Изработка по размер */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
        Чаршафи с ластик от 100% памук – изработка по размер на матрак
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
        Чаршафите с ластик са практично решение за всяко легло, защото прилягат добре по матрака и
        остават стабилно на място по време на сън. При нас можете да поръчате чаршафи с ластик по
        размер на матрак, изработени от 100% памук и съобразени с параметрите на вашето легло.
      </Typography>
      <Collapse in={expanded} collapsedSize={0}>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Използваме висококачествени памучни платове като ранфорс и памучен сатен, които осигуряват
          комфорт, добра дишаемост и приятно усещане при допир. Платовете са сертифицирани по
          OEKO-TEX Standard 100, което гарантира безопасност на текстила и липса на вредни вещества.
          Чаршафите с ластик са подходящи както за стандартни легла, така и за матраци с
          нестандартни размери, което ги прави удобен избор за различни видове спални.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Ако търсите конкретна материя, можете да разгледате и нашите:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi-s-lastik/1/3/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик ранфорс
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/produkti/spalno-belio/charshafi-s-lastik/1/3/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи с ластик памучен сатен
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          За да създадете цялостен комплект спално бельо, можете да комбинирате чаршафите и с:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/plikove-za-zavivka/1/4"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            пликове за завивки
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/kalufki/1/2"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            калъфки за възглавници
          </Typography>
          <Typography
            variant="body1"
            component={Link}
            to="/kategorii/spalno-belio/charshafi/1/1"
            sx={{ ...seoLinkStyle, display: 'block', mb: 0.5 }}>
            чаршафи без ластик
          </Typography>
        </Box>

        {/* H2: Стандартни и нестандартни размери */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Чаршафи с ластик за стандартни и нестандартни размери матраци
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          В нашия магазин можете да поръчате чаршафи с ластик за стандартни и нестандартни размери
          матраци, например:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {[
            '80/200',
            '90/200',
            '100/200',
            '120/200',
            '140/200',
            '160/200',
            '180/200',
            '200/200'
          ].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            и други.
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Изработката по индивидуален размер позволява чаршафът да пасва добре дори при
          по-специфични матраци. Това решение е особено подходящо за:
        </Typography>
        <Box component="ul" sx={{ mb: 4, pl: 4, color: 'text.secondary' }}>
          <li>матраци с нестандартни размери</li>
          <li>легла тип боксспринг (boxspring)</li>
          <li>матраци с топ матрак</li>
          <li>по-високи матраци</li>
        </Box>

        {/* H2: Какви чаршафи ще откриете */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Какви чаршафи с ластик ще откриете в нашия магазин
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          В нашия онлайн магазин ще откриете разнообразие от чаршафи с ластик, подходящи за различни
          видове легла и матраци:
        </Typography>
        <Box component="ul" sx={{ mb: 4, pl: 4, color: 'text.secondary' }}>
          <li>чаршафи с ластик за единично легло</li>
          <li>чаршафи с ластик за двойно легло</li>
          <li>чаршафи с ластик за висок матрак</li>
          <li>чаршафи с ластик за нестандартни размери</li>
        </Box>

        {/* H2: Най-търсени размери */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Най-търсени размери чаршафи с ластик
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Сред най-популярните размери са:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            <strong>Чаршаф с ластик за матрак 90/200 (90х200) см</strong>
            <br />
            Подходящ за стандартни единични легла.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            <strong>Чаршаф с ластик за матрак 100/200 (100х200) см</strong>
            <br />
            Удобен избор за по-широки единични легла.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            <strong>Чаршаф с ластик за матрак 120/200 (120х200) см</strong>
            <br />
            Подходящ за по-широки единични легла или компактни двойни легла.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            <strong>Чаршаф с ластик за матрак 140/200 (140х200) см</strong>
            <br />
            Често използван размер за компактни двойни легла.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            <strong>Чаршаф с ластик за матрак 160/200 (160х200) см</strong>
            <br />
            Един от най-предпочитаните размери за двойни легла.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            <strong>Чаршаф с ластик за матрак 180/200 (180х200) см</strong>
            <br />
            Подходящ за по-големи двойни легла.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            <strong>Чаршаф с ластик за матрак 200/200 (200х200) см</strong>
            <br />
            Подходящ за големи двойни легла.
          </Typography>
          <Typography variant="body1" sx={{ mb: 1.5, color: 'text.secondary' }}>
            <strong>Чаршаф с ластик за матрак 220/200 (220х200) см</strong>
            <br />
            Подходящ за много големи двойни легла.
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на индивидуалната изработка можете да изберете подходящата височина на
          чаршафа, съобразена с дебелината на матрака.
        </Typography>

        {/* H2: Висок матрак */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Чаршаф с ластик за висок матрак
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          При по-високи матраци стандартните чаршафи често не са достатъчно дълбоки и могат да се
          измъкват от ъглите на леглото. Затова нашите чаршафи с ластик се изработват според
          височината на матрака, за да прилягат стабилно и да остават на мястото си по време на сън.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Предлагаме изработка на чаршафи с ластик за висок матрак с височина:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>10 см</li>
          <li>15 см</li>
          <li>20 см</li>
          <li>25 см</li>
          <li>30 см</li>
          <li>40 см</li>
          <li>50 см</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          При нас можете да поръчате и:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>чаршаф с ластик за дебел матрак</li>
          <li>чаршаф с ластик за матрак 30 см</li>
          <li>чаршаф с ластик за матрак 40 см</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          При изработката се предвижда необходимият запас за естествената свиваемост на памучния
          плат, както и за правилното прилягане около матрака. Това гарантира, че чаршафът обхваща
          добре матрака и остава стабилен дори при по-високи или по-дебели матраци.
        </Typography>

        {/* H2: Дълъг матрак 210 и 220 см */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Чаршаф с ластик за дълъг матрак 210 и 220 см
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Освен стандартните размери предлагаме и чаршафи с ластик за дълги матраци с дължина 210 и
          220 см, например:
        </Typography>
        <Box sx={{ mb: 2, pl: 2 }}>
          {['90/210', '100/210', '120/210', '140/210', '160/210', '180/210', '200/210'].map(
            (size) => (
              <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
                {size}
              </Typography>
            )
          )}
        </Box>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          както и размери с дължина 220 см, например:
        </Typography>
        <Box sx={{ mb: 4, pl: 2 }}>
          {['90/220', '120/220', '140/220', '160/220', '180/220', '200/220'].map((size) => (
            <Typography key={size} variant="body1" sx={{ color: 'text.secondary' }}>
              {size}
            </Typography>
          ))}
        </Box>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Тези размери са подходящи за по-високи хора или за легла със специфични размери.
        </Typography>

        {/* H2: Нестандартен матрак */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Чаршаф с ластик за нестандартен матрак
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          При нас можете да поръчате чаршаф с ластик по размер на матрак, съобразен с точните
          параметри на вашето легло. Това е практично решение, когата матракът е с нестандартни
          размери.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Изработваме чаршафи с ластик за нестандартни матраци, като се съобразяваме с точната
          ширина, дължина и височина на матрака. Така можете да поръчате чаршаф, който пасва идеално
          дори при по-специфични размери.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Благодарение на индивидуалната изработка чаршафът обхваща добре матрака и остава стабилно
          на мястото си по време на сън.
        </Typography>

        {/* H2: Популярни търсения */}
        <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 2 }}>
          Популярни търсения при чаршафите с ластик
        </Typography>
        <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
          Клиентите често търсят чаршаф с ластик по размер на матрака или според типа легло. Сред
          най-често търсените варианти са:
        </Typography>
        <Box component="ul" sx={{ mb: 2, pl: 4, color: 'text.secondary' }}>
          <li>чаршаф с ластик 90/200 (90х200) см</li>
          <li>чаршаф с ластик 120/200 (120х200) см</li>
          <li>чаршаф с ластик 140/200 (140х200) см</li>
          <li>чаршаф с ластик 160/200 (160х200) см</li>
          <li>чаршаф с ластик 180/200 (180х200) см</li>
          <li>чаршаф с ластик за висок матрак</li>
          <li>чаршаф с ластик за нестандартен матрак</li>
        </Box>
        <Typography variant="body1" sx={{ mb: 2, color: 'text.secondary' }}>
          Чаршаф с ластик 160/200 (160х200) см е един от най-предпочитаните размери за двойни легла
          и стандартни матраци.
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Също много търсени са размерите чаршаф с ластик 140/200 (140х200) см и чаршаф с ластик
          180/200 (180х200) см, които също са подходящи за двойни легла.
        </Typography>
      </Collapse>
      <Button
        onClick={() => setExpanded(!expanded)}
        sx={{
          color: '#F57819',
          textTransform: 'none',
          fontWeight: 600,
          mb: 3,
          '&:hover': { backgroundColor: 'rgba(212, 175, 55, 0.08)' }
        }}>
        {expanded ? 'Скрий' : 'Прочетете повече'}
      </Button>

      {/* H2: ЧЗВ */}
      <Typography variant="h5" component="h2" fontWeight={700} sx={{ mb: 3 }}>
        Често задавани въпроси за чаршафи с ластик
      </Typography>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилния размер чаршаф с ластик?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            За да изберете правилния размер чаршаф с ластик, трябва да знаете ширината, дължината и
            височината на матрака. При поръчка тези параметри се вземат предвид, за да може чаршафът
            да прилегне добре и да обхване стабилно матрака.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да измеря правилно матрака?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Измерете три основни параметъра:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>ширина – разстоянието от едната до другата страна на матрака</li>
            <li>дължина – разстоянието от горната до долната част</li>
            <li>височина – дебелината на матрака</li>
          </Box>
          <Typography variant="body1" sx={{ mt: 1, color: 'text.secondary' }}>
            Тези размери са необходими, за да може чаршафът да бъде изработен така, че да пасва
            добре.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Как да избера правилната височина на чаршафа с ластик?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            При поръчка е важно да посочите височината на матрака. Например при матрак с височина
            около 25 см:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>
              ако искате чаршафът да следва приблизително височината на матрака – изберете 21–25 см
            </li>
            <li>
              ако искате чаршафът да обхваща матрака по-добре и да се подпъхва под матрака –
              изберете 26–30 см или 31–40 см
            </li>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Подходящи ли са чаршафите с ластик за високи матраци?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Да. Чаршафите могат да бъдат изработени за матраци с различна височина и са подходящи
            както за стандартни, така и за по-високи матраци, включително:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>матраци с топ матрак</li>
            <li>ортопедични матраци</li>
            <li>легла тип боксспринг (boxspring)</li>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Свиват ли се памучните чаршафи при пране?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Памучните платове могат да имат естествена свиваемост около 4–5% след пране. При
            изработката се предвижда необходимият запас, така че чаршафът да пасва добре и след
            пране.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            От какъв плат са изработени чаршафите с ластик?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ mb: 1, color: 'text.secondary' }}>
            Чаршафите се изработват от 100% памук, като можете да избирате между две основни
            материи:
          </Typography>
          <Box component="ul" sx={{ pl: 4, color: 'text.secondary', mt: 0 }}>
            <li>ранфорс – здрав и дишащ памучен плат, подходящ за ежедневно използване</li>
            <li>памучен сатен – по-гладка и фина памучна материя с лек естествен блясък</li>
          </Box>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            Могат ли чаршафите да се изработят по индивидуален размер?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Да. Чаршафите с ластик се изработват по индивидуални параметри според размера на
            матрака, което позволява да поръчате чаршаф, който пасва точно на вашето легло.
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography component="h3" fontWeight={600}>
            За колко време се изработват чаршафите?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            Чаршафите се изработват по поръчка. Обичайният срок за изработка е между 3 и 10 работни
            дни, като в повечето случаи поръчките са готови в рамките на 4–7 работни дни.
          </Typography>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
}
